import { message } from 'antd';

export const openWxminiShop = async (accId, shopId) => {
  
    let newWindow = window.open('', '_blank');
    // console.log('shopId', currentShopId);

    const response = await fetch(`/api/wxopen/wx-mini-url`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            accId,
            shopId,
        })
    });
    const result = await response.json();

    if(result.success) {
        if(newWindow) {
            newWindow.location.href = result.data.url_link;
        }
    } else {
        if(newWindow) {
            newWindow.close();
        }
        message.error(result.data);
    }
}